import { RootState } from "@redux/store";

export const rentSelector = (state: RootState) => state.rent;
